import { OptionDropdown } from "@/components/OptionDropdown";
import { MenuItemType, ProjectUserPermissions } from "@/enums";
import { generateMenuItems } from "@/helpers/generateMenuItems";
import { useProjectContext } from "@/providers";
import { useGetProjectTemplateQuery } from "@/services";
import { useIntl } from "react-intl";

const ScheduleDropdownActionsButton = () => {
  const intl = useIntl();
  const { openMilestoneModal } = useProjectContext();
  const { project, canUser } = useProjectContext();

  const { data: projectTemplate } = useGetProjectTemplateQuery(
    project.projectTemplateId,
    {
      skip: !project?.projectTemplateId,
    }
  );

  const canAddMilestone = canUser(ProjectUserPermissions.AddMilestones, null);

  const handleMenuActions = (e) => {
    switch (e.key) {
      case "add":
        openMilestoneModal(null);
        break;
      case "vigorTemplates":
        window.open(projectTemplate.vigorTemplateUrl);
        break;
      default:
        break;
    }
  };

  const menuItems = [
    {
      type: MenuItemType.Item,
      key: "add",
      title: intl.formatMessage({
        id: "addMilestonesModal.btnLabel",
      }),
      visible: canAddMilestone,
    },
    {
      type: MenuItemType.Item,
      key: "vigorTemplates",
      title: intl.formatMessage({
        id: "project.vigorTemplatesLabel",
      }),
      requiredRight: projectTemplate?.vigorTemplateUrl?.length > 0,
    },
  ];

  return (
    <>
      {Object.keys(project).length && (
        <OptionDropdown
          items={generateMenuItems(menuItems)}
          id={project.id}
          handleMenuClick={handleMenuActions}
        />
      )}
    </>
  );
};

export { ScheduleDropdownActionsButton };
